module.exports = __webpack_public_path__ + "static/media/fl_cast_kgoedel.676ae821.jpg";